import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { tipStarted } from '../orderTracking/actions';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppWrapper from '../app';
import TipRateForm from './TipRateForm';
import RateExperienceForm from './RateExperienceForm';
import Header from './Header';
import Close from 'images/icons/controls/close.svg?react-svg';
import { Title } from 'scy/text';
import { BUTTON_CLASSES } from 'scy/buttons';
import { textRight } from 'scy/utils.mod.scss';
import { inlineBlock } from 'scy/display.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function TipAndRate() {
  const { order } = useSelector(state => state.orderTracking);
  const courier = order.driver || {};

  const [showTipRate, setShowTipRate] = useState(
    order.order_tip == null || order.order_rating == null
  );
  const [isComplete, setIsComplete] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(tipStarted());
  }, [dispatch]);

  return (
    <AppWrapper renderHeader={props => <Header {...props} />}>
      <div className={styles.pageContainer}>
        {isComplete ? (
          <>
            <Title uppercase responsive className={styles.postFeedbackTitle}>
              Thanks for your feedback!
            </Title>
            <div
              className={classnames(
                styles.formContainer,
                margin.tablet_bottom_xl
              )}
            >
              <Link
                to="/"
                className={classnames(
                  BUTTON_CLASSES.primary,
                  styles.primaryButton,
                  inlineBlock
                )}
              >
                Done
              </Link>
            </div>
          </>
        ) : (
          <>
            <div className={textRight}>
              <Link to="/">
                <Close />
              </Link>
            </div>

            {showTipRate ? (
              <TipRateForm
                order={order}
                courier={courier}
                handleSuccess={() => setShowTipRate(false)}
              />
            ) : (
              <RateExperienceForm
                orderId={order._id}
                handleSuccess={() => setIsComplete(true)}
              />
            )}
          </>
        )}
      </div>
    </AppWrapper>
  );
}
